export default __webpack_public_path__ + "static/media/Logo.b014e776.png";